import React, { useState, useCallback } from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/uiconfig';
import { EntryPageTemplate } from 'gw-components-platform-react';
import { Loader } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';
import { generateURL } from 'gw-portals-url-js';
import metadata from './EntryPage.metadata.json5';
import styles from './EntryPage.module.scss';
import './EntryPage.messages';

const VIEWS = {
    logInView: 'LOG_IN_VIEW',
    signUpView: 'SIGN_UP_VIEW',
    forgotPasswordView: 'FORGOT_PASSWORD_VIEW',
    forgotUsernameView: 'FORGOT_Username_VIEW',

};

const { applicationDetails } = appConfig;

function EntryPage({ location }) {
    const { isAuthInProgress } = useAuthentication();
    const [view, updateView] = useState(VIEWS.logInView);
    const { state } = location;

    const curYear = new Date().getFullYear();

    const handleForgotPasswordClick = useCallback(() => {
        updateView(VIEWS.forgotPasswordView);
    }, []);

    const handleForgotUsernameClick = useCallback(() => {
        updateView(VIEWS.forgotUsernameView);
    }, []);

    const handleSignUpClick = useCallback(() => {
        updateView(VIEWS.signUpView);
    }, []);

    const handleSignInClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    
    const generateRIRegistrationURL = () => {
        const getUrl = window.location;
        const baseUrl = `${getUrl.origin}/ph/registration/#/`;
        let params = {};
        return generateURL(baseUrl, params);
    };    


    if (isAuthInProgress) {
        return <Loader loaded={!isAuthInProgress} />;
    }

    var isOKTAEnabled = true;// _.get(appConfig, 'authentication.okta.enabled', false);

    const overrideProps = {
        gwLoginComponent: {
            successPath: _.get(state, 'from.pathname') || '/home'
        },
        logInViewContainer: {
            visible: view === VIEWS.logInView
        },
        signUpLinkContainer: {
            visible: !isOKTAEnabled
        },
        signUpViewContainer: {
            visible: view === VIEWS.signUpView
        },
        NeedHelpLinkContainer: {
            visible: !isOKTAEnabled
        },
        legalContainer: {
            visible: !isOKTAEnabled
        },
        forgotPasswordViewContainer: {
            visible: view === VIEWS.forgotPasswordView
        },
        forgotUsernameViewContainer: {
            visible: view === VIEWS.forgotUsernameView
        },
        signUpLink: {
            href: generateRIRegistrationURL()
        },
        legalText: {
            content: ` © 2001-${curYear} Republic Indemnity Company of America. All rights reserved.`
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onForgotPasswordClick: handleForgotPasswordClick,
            onForgotUsernameClick: handleForgotUsernameClick,
            onSignUpClick: handleSignUpClick,
            onSignInClick: handleSignInClick
        }
    };

    const renderedContentFromMetadata = <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrideProps}
        {...resolvers}
    />;

    if (isOKTAEnabled) {
        return renderedContentFromMetadata;
    } else {
    return (
        <EntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
        />
    );
}
}

EntryPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

EntryPage.defaultProps = {
    location: {}
};

export default EntryPage;
